import React, {cloneElement, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';
import DragIndicatorOutlinedIcon from '@material-ui/icons/DragIndicatorOutlined';

const useStyles = makeStyles({
    grow: {
        flexGrow: 1,
    },
    root: {},
    toolbar: {
        marginBottom: 0,
        minHeight: 0,
    },
    card: {
        height: '100%',
        '& .MuiCardContent-root': {
            padding: 8
        }
    }
});

const BaseCard = props => {
    const classes = useStyles();

    return (
        <Card className={classes.card} style={{height: props.height, width: props.width}}>
            <CardContent>
                <AppBar position="static" color="default" className={classes.toolbar}>
                    <Toolbar variant="dense" className={classes.toolbar}>
                        <IconButton
                            className="dragger"
                            color="inherit"
                            aria-label="drag"
                            size="small"
                        >
                            <DragIndicatorOutlinedIcon/>
                        </IconButton>
                        <Typography variant="subtitle2" color="inherit">
                            {props.title}
                        </Typography>
                        <div className={classes.grow}/>
                        {<IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="shrink"
                            onClick={() => {
                                alert('This does not do anything yet')
                            }}
                            size="small">
                            <ArrowDropDownOutlinedIcon/>
                        </IconButton>}
                    </Toolbar>
                </AppBar>
                {cloneElement(props.children, {height: props.height, width: props.width})}
            </CardContent>
        </Card>
    );
};

export default BaseCard
